import { Box, Typography } from '@mui/material';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import SouthEastIcon from '@mui/icons-material/SouthEast';
import { round } from '@kheops/utils';
import i18n from '../../i18n';
import { KheopsTypographyVariant } from '../../providers/CustomThemeProvider';

interface VersionedPriceProps {
  currentValue: number;
  color: string;
  previousValue?: number | null;
  valueFormatter?: (value: number | bigint) => string;
  shouldHighlightDifference?: boolean;
  variant: KheopsTypographyVariant;
}

export default function VersionedValue({ currentValue, previousValue, color, shouldHighlightDifference, variant, valueFormatter }: VersionedPriceProps): React.JSX.Element {
  const numberFormat = new Intl.NumberFormat(i18n.resolvedLanguage, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });
  const shouldDisplayPriceDifference = (previousValue !== undefined && previousValue !== null)
    && round(previousValue, 3) !== round(currentValue, 3);
  const isPreviousInferiorToCurrent = shouldDisplayPriceDifference && previousValue < currentValue;
  const formatter = valueFormatter ?? numberFormat.format;

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          color: shouldDisplayPriceDifference && shouldHighlightDifference ? 'warning.main' : color,
          alignItems: 'center',
          minHeight: 24,
          gap: 0.5,
        }}
      >
        <Typography
          variant={variant}
          sx={{
            color: shouldDisplayPriceDifference && shouldHighlightDifference ? 'warning.main' : color,
            lineHeight: 1,
          }}
        >
          {formatter(currentValue)}
        </Typography>
        { shouldDisplayPriceDifference
            && (isPreviousInferiorToCurrent
              ? <NorthEastIcon sx={{ fontSize: '0.875rem' }} />
              : <SouthEastIcon sx={{ fontSize: '0.875rem' }} />)}
      </Box>
      { shouldDisplayPriceDifference && (
      <Typography color="onSurfaceVariant" variant="bodySmall" sx={{ textDecorationLine: 'line-through' }}>
        {formatter(previousValue)}
      </Typography>
      ) }
    </Box>
  );
}
